export default {
    MODULE: 'module',
    TABLE: 'table'
};
